import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../index.css";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Commonheader from "../CommonUtils/Commonheader";
import { FaDatabase } from "react-icons/fa";
import { IoToggleOutline } from "react-icons/io5";
import { MenuItem } from "./ParentSection";
import { CommonFooter, CommonHeaders } from "../CommonUtils/CommonHeaderFooter";
import { MdMenu } from "react-icons/md";

export default function RusaDashboard() {
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 576);
    const [activeMenu, setActiveMenu] = useState(null);
    const [accessibleMenu, setAccessibleMenu] = useState(false);

    // ── FIX: only one parent section open at a time (accordion) ────────────
    const [openParentId, setOpenParentId] = useState(null);

    const menuData = JSON.parse(sessionStorage.getItem("menuData")) || [];

    const filteredMenu = [...menuData].sort(
        (a, b) => (a.priority || 0) - (b.priority || 0)
    );

    const parents = filteredMenu.filter((item) => item.parent_id === 0);
    const childrenList = filteredMenu.filter((item) => item.parent_id !== 0);
    const hasHierarchy = parents.length > 0 && childrenList.length > 0;

    useEffect(() => {
        setAccessibleMenu(filteredMenu.length > 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setActiveMenu("home");
    }, []);

    useEffect(() => {
        const onResize = () => setSidebarOpen(window.innerWidth > 576);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    // ── Auto-expand whichever parent contains the active child ─────────────
    useEffect(() => {
        const activeParent = parents.find((p) =>
            childrenList.some((c) => c.parent_id === p.service_id && c.service_name === activeMenu)
        );
        setOpenParentId(activeParent ? activeParent.service_id : null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeMenu]);

    const handleToggleParent = (serviceId) => {
        setOpenParentId((prev) => (prev === serviceId ? null : serviceId));
    };

    const handleSelect = (serviceName) => {
        setActiveMenu(serviceName);
        navigate(`/${serviceName}`);
        if (window.innerWidth <= 576) {
            setSidebarOpen(false);
        }
    };

    // ── Build menu items ────────────────────────────────────────────────────
    const menuItems = hasHierarchy
        ? parents.map((parent) => ({
            item: parent,
            kids: childrenList
                .filter((c) => c.parent_id === parent.service_id)
                .sort((a, b) => (a.priority || 0) - (b.priority || 0)),
        }))
        : filteredMenu.map((item) => ({ item, kids: [] }));

    return (
        <>
            <Commonheader />
            {accessibleMenu && (
                <>
                    {sidebarOpen && window.innerWidth <= 576 && (
                        <div className="sidebar-backdrop" onClick={() => setSidebarOpen(false)}
                            onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") setSidebarOpen(false); }} />
                    )}
                    <div className="dashboard-container second-dash">
                        <div className="main-area1">
                            <aside className={`sidebar ${sidebarOpen ? "open" : "closed"}`}>
                                <Button
                                    className="toggle-btn"
                                    onClick={() => setSidebarOpen(!sidebarOpen)}
                                >
                                    <MdMenu size={22} />
                                </Button>
                                <ul className={`sidebar-menu ${sidebarOpen ? "open" : "closed"}`}>
                                    {menuItems.map(({ item, kids }) => (
                                        <MenuItem
                                            key={item.service_id}
                                            item={item}
                                            kids={kids}
                                            activeMenu={activeMenu}
                                            onSelect={handleSelect}
                                            sidebarOpen={sidebarOpen}
                                            defaultIcon={FaDatabase}
                                            isOpen={openParentId === item.service_id}
                                            onToggle={() => handleToggleParent(item.service_id)}
                                        />
                                    ))}
                                </ul>
                                <div className="sidebar-footer">
                                    <p className="mb-0">
                                        Powered By
                                        {/* 
                                        <a href="https://apcfss.in/" target="_blank" rel="noreferrer">
                                            <img src="../images/apcfss-logo-white.svg" alt="" className="img-fluid" />
                                        </a> */}


                                        <a href="https://apcfss.in/" target="_blank" rel="noreferrer">
                                            <img
                                                src="/images/apcfss-logo-white.svg"
                                                alt="APCFSS Logo"
                                            />
                                        </a>
                                    </p>
                                </div>
                            </aside>
                        </div>
                    </div>
                </>
            )}
            {/* <CommonFooter /> */}
        </>
    );
}